import React from 'react'
import { PageProps } from 'gatsby'

// Lazy loading
import loadable from '@loadable/component'

export interface BannerProps {
  // eslint-disable-next-line camelcase
  fields: GatsbyTypes.WpPost_Flexcontent_Flex_Banner
  location: PageProps['location']
}

interface BannersProps {
  [key: string]: any
}

const BannerShell: React.FC<BannerProps> = ({ fields, location }) => {
  const banners: BannersProps = {
    ribbon: loadable(() => import('components/flex/Banner/BannerDefault')),
    wavy: loadable(() => import('components/flex/Banner/BannerWavy')),
  }

  if (!fields.styletype || !banners[fields.styletype]) {
    return null
  }

  const Component = banners[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default BannerShell
